import { motion } from 'motion/react'
import { createPortal } from 'react-dom'
import { useToaster } from 'react-hot-toast/headless'

import { cn } from 'utils/cn'

import type { FC, ReactNode } from 'react'
import type { Toast as ToastType } from 'react-hot-toast'

export const NotificationsWrapper: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const { toasts, handlers } = useToaster()
  const { startPause, endPause, calculateOffset, updateHeight } = handlers

  return (
    <>
      {createPortal(
        toasts.map((toast) => {
          const Toast = toast.message as FC<ToastType>
          const offset = calculateOffset(toast, {
            reverseOrder: false,
          })

          const ref = (el: HTMLDivElement) => {
            if (el && !toast.height) {
              const { height } = el.getBoundingClientRect()
              updateHeight(toast.id, height)
            }
          }

          return (
            <motion.div
              key={toast.id}
              style={{
                zIndex: 10000000,
              }}
              onMouseEnter={startPause}
              onMouseLeave={endPause}
              ref={ref}
              animate={{ translateY: offset }}
              className={cn(toast.className, 'w-fit top-4 right-4 fixed')}
              {...toast.ariaProps}
            >
              <Toast {...toast} />
            </motion.div>
          )
        }),
        document.body,
      )}
      {children}
    </>
  )
}
